import React from 'react';

import { Row, Column, Header } from '@ard-online/component-styleguide';

import { InteractiveMap } from '../styles';

const interactiveMap = require("../images/ard-kka_interaktive_grafik.jpg");
const interactiveMapRetina = require("../images/ard-kka_interaktive_grafik@2x.jpg");
const interactiveMapMobile = require("../images/ard-kka_interaktive_grafik_mobile.jpg");
const logo = require("../images/logo_ard-ci.svg");
const ardAllYours = require("../images/logo_ard-wir-sind-deins.svg");

export default function HomeSection() {
  return (
    <section id="home">
      <Row>
        <Column all={12} s={6} className="center-vertical">
          <h2>Entdecken Sie die ARD: Deutschlands größten öffentlich-rechtlichen Senderverbund </h2>
          <p>Mit der ARD treffen Sie die erste Wahl. Wir bieten Ihnen</p>
          <ul>
            <li>erstklassige deutsche Programme, um Ihr Portfolio attraktiver zu gestalten,</li>
            <li>die Vielfalt, mit der Sie ein breites Publikum ansprechen sowie</li>
            <li>herausragende Informationsformate und packende Unterhaltungssendungen.</li>
          </ul>
          <p>Wählen Sie Ihr Senderpaket aus 16 Fernseh- und über 60 Hörfunkprogrammen: angefangen von Deutschlands beliebtem nationalen TV-Programm <nobr>Das Erste</nobr> über die regionalen Fernseh- und Radioprogramme bis hin zu verschiedenen digitalen TV-Kanälen.</p>
          <p>ARD Channels International lizenziert die ARD-Sender an Netzbetreiber in ganz Europa außerhalb Deutschlands.</p>
          <div><img className="allYours" src={ardAllYours} alt="Wir sind deins. ARD"/></div>
        </Column>
        <Column all={12} s={6}>
        <InteractiveMap>
          <img className="mobile" src={interactiveMapMobile}/>
          <img className="standard" src={interactiveMap} srcset={`
            ${interactiveMapRetina} 2x
          `}/>
          <ul>
            <li id="im-tile2" className="tile">
              <a href="javascript:void(0);"><span>Unabhängigkeit</span></a>
              <div className="tooltip">
                <div className="inner">
                  Die ARD gehört in Deutschland der Gemeinschaft. Daraus ergibt sich unsere Verantwortung, alle Menschen ausgewogen, unparteiisch und umfassend über wichtige politische und gesellschaftliche Ereignisse zu informieren. Die ARD sendet weitestgehend werbefrei. Während der abendlichen Hauptsendezeit können Sie unsere Programme gänzlich ohne Werbeunterbrechungen genießen.
                </div>
              </div>
            </li>
            <li id="im-tile1" className="tile">
              <a href="javascript:void(0);"><span>Qualität</span></a>
              <div className="tooltip">
                <div className="inner">
                  Wir stehen für hochwertigen Journalismus und Programminhalte mit eigenem Profil. Durch aktuelle Berichterstattung, hintergründige Reportagen und Dokumentationen bieten wir Orientierung in der globalen Informationsgesellschaft. Über 100 Korrespondent:innen in 26 Ländern berichten für die ARD direkt aus dem Ausland, um ein besseres Verständnis für weltweite Zusammenhänge zu vermitteln.
                </div>
              </div>
            </li>
            <li id="im-tile3" className="tile">
              <a href="javascript:void(0);"><span>Regionalität</span></a>
              <div className="tooltip">
                <div className="inner">
                  Die neun ARD-Landesrundfunkanstalten sind in allen Regionen Deutschlands tief verwurzelt und spiegeln das Land wider, wie es ist: seine Traditionen, Mentalitäten und Eigenarten ebenso wie das tägliche Geschehen in der Stadt und auf dem Land.
                </div>
              </div>
            </li>
            <li id="im-tile4" className="tile">
              <a href="javascript:void(0);"><span>Verlässlichkeit</span></a>
              <div className="tooltip">
                <div className="inner">
                  In schwierigen Zeiten wie der Covid-19-Krise zeigt sich, wie wichtig verlässliche Nachrichtenquellen sind: Mit durchschnittlich fast 12 Millionen Zuschauer:innen und 40 % Marktanteil zur besten Sendezeit in Deutschland erzielte die "Tagesschau" im Jahr 2020 neue Rekordquoten – weit vor allen konkurrierenden Nachrichtensendungen.
                </div>
              </div>
            </li>
            <li id="im-tile6" className="tile">
              <a href="javascript:void(0);"><span>Vielfalt</span></a>
              <div className="tooltip">
                <div className="inner">
                  Das Angebot der ARD ist so vielfältig wie Deutschland. Ob Nachrichten oder Sport, Kabarett oder Comedy, Spielfilm oder Hörspiel, Popmusik oder Klassikkonzerte – wir bieten allen Menschen ein Programm, in dem sie sich wiederfinden. Fesselnde Sendungen zu kulturellen, künstlerischen und wissenschaftlichen Themen beweisen, wie spannend und unterhaltsam Bildung sein kann.
                </div>
              </div>
            </li>
            <li id="im-tile5" className="tile">
              <a href="javascript:void(0);"><span>Unterhaltung</span></a>
              <div className="tooltip">
                <div className="inner">
                  Preisgekrönte Spielfilme und Serien, mitreißende Familienunterhaltung und freche Comedy-Shows: Die ARD produziert und sendet erstklassige Unterhaltungssendungen für ein breites Publikum, wie die beliebteste Krimi-Reihe der Deutschen, den „Tatort“, oder weltweit erfolgreiche Serien wie „Babylon Berlin“.
                </div>
              </div>
            </li>
            
          </ul>
        </InteractiveMap>
      </Column>
      </Row>
    </section>
  );
}